import { render, staticRenderFns } from "./VideoChoose.vue?vue&type=template&id=cfdfa496&scoped=true"
import script from "./VideoChoose.vue?vue&type=script&lang=js"
export * from "./VideoChoose.vue?vue&type=script&lang=js"
import style0 from "./VideoChoose.vue?vue&type=style&index=0&id=cfdfa496&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfdfa496",
  null
  
)

export default component.exports